import { Component, Input } from '@angular/core';
import { SimulationTracker } from '../../interfaces/simulation-tracker';
import { SimulationTrackerDataService } from '../../services/simulation-tracker-data.service';

@Component({
  selector: 'app-simulation-tracker-details-list',
  templateUrl: './simulation-tracker-details-list.component.html',
})
export class SimulationTrackerDetailsListComponent {
  constructor(private simulationTrackerDataService: SimulationTrackerDataService) {}
  private _simulationTracker?: SimulationTracker | null = null;

  @Input()
  set simulationTracker(value: SimulationTracker | null) {
    this._simulationTracker = value;

    if(value)
      this.trackerDetails = this.simulationTrackerDataService.getSimulationTrackerDetails(value);
  }

  get simulationTracker(): SimulationTracker | null {
    return this._simulationTracker ?? null;
  }

  trackerDetails: { label: string; tooltip?: string; value: string | number }[] = [];
}
